<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in company here"
                  append-icon="search"
                  label="Search company banks"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />
              
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-companies-banks-dialog-create
                  v-if="$hasPermissionTo(['create company banks'])"
                  :company-banks="companyBanks"
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="companyBanks"
            :loading="tableLoading"
            :search="search"
            show-expand
            item-key="id"
            single-expand
          >
            <template v-slot:item.company.name="{ item }">
              <div>
                <span>
                  {{ item.company.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.company.banks="{ item }">
              <div>
                <span>
                  <v-chip
                    v-for="bank in item.banks "
                    :key="bank.id"
                    class="mx-1"
                  >
                    {{ bank.name }}
                  </v-chip>
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <setup-companies-banks-dialog-edit
                v-if="$hasPermissionTo(['update company banks'])"
                :company-bank="item"
                @updated="loadData"
              />
            </template> 

            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="12"
                class="selectedRow"
              >
                <div class="py-2 px-2 my-2">
                  <v-data-table
                    hide-default-footer
                    :items="item.details"
                    :headers="detailHeaders"
                    dense
                    class="header-border disable-pointer-event "
                  >
                    <template v-slot:item.payroll_bank.name="{ item }">
                      <div>
                        <span>
                          {{ item.payroll_bank.name }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:item.bank_account_no="{ item }">
                      <div>
                        <span>
                          {{ item.bank_account_no ? item.bank_account_no:'N/A' }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:item.originator_id="{ item }">
                      <div>
                        <span>
                          {{ item.originator_id ? item.originator_id:'N/A' }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:item.company_registered_id="{ item }">
                      <div>
                        <span>
                          {{ item.company_registered_id ? item.company_registered_id:'N/A' }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:item.short_name="{ item }">
                      <div>
                        <span>
                          {{ item.short_name ? item.short_name:'N/A' }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:item.is_default="{ item }">
                      <div>
                        <v-icon
                          v-if="item.is_default"
                          color="success"
                        >
                          mdi-check
                        </v-icon>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupCompaniesBanksDialogCreate: () => import('@/components/setup/companies/banks/DialogCreate'),
      SetupCompaniesBanksDialogEdit: () => import('@/components/setup/companies/banks/DialogEdit'),
    },
    data () {
      return {
        companyBanks: [],
        headers: [
          {
            text: 'Company',
            align: 'left',
            value: 'company.name',
          },
          {
            text: 'Banks',
            align: 'left',
            value: 'company.banks',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        detailHeaders: [
          { text: 'Bank', value: 'payroll_bank.name' },
          { text: 'Bank Account No', value: 'bank_account_no' },
          { text: 'Originator ID', value: 'originator_id' },
          { text: 'Company Registered ID', value: 'company_registered_id' },
          { text: 'Short Name', value: 'short_name' },
          { text: 'Default', value: 'is_default', align: 'center' },
        ],
        search: '',
        tableLoading: false,
      }
    },

    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.tableLoading = true

        this.$api.companyBanks().list()
          .then(res => {
            let temp = []
            _.chain(res.data)
              .groupBy('company_id')
              .map((value, key) => {
                temp.push({
                  id: key,
                  company: this.getCompany(value),
                  banks: this.getBanks(value),
                  details: value,
                })
              })
              .value()

            this.companyBanks = _.orderBy(temp, ['company.name'], ['asc'])
            this.tableLoading = false
          })
      },

      getCompany (value) {
        return value[0].company
      },

      getBanks (value) {
        let banks = []

        value.map(item => {
          banks.push(item.payroll_bank)
        })

        return banks
      },

    },
  }
</script>
<style scoped>
.header-border{
  border:1px solid black
}

.selectedRow {
  background-color: rgb(190,216,249)
}

</style>
